import { inject, provideAppInitializer, Provider } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { TranslateModuleConfig } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

import { TranslationLoaderService } from '@common/services/translation-loader.service';
import { createTranslationModuleConfig } from '@common/helpers/translations';

// MODULE
export const apiTransLoaderFactory = (http: HttpClient, cookieService: CookieService): TranslationLoaderService => {
    return new TranslationLoaderService(http, cookieService);
};

export const translationsModuleConfig: TranslateModuleConfig = createTranslationModuleConfig(apiTransLoaderFactory, [
    HttpClient,
    CookieService,
]);
// END MODULE

// PROVIDER
function initializeTranslations(translate: TranslateService, cookieService: CookieService): () => Promise<unknown> {
    return async () => {
        translate.use(TranslationLoaderService.getCurrentLocale(cookieService));
        return new Promise<void>((resolve) => {
            translate.onLangChange.subscribe(() => {
                resolve();
            });
        });
    };
}

export const translationProviderConfig = provideAppInitializer(() => {
    const initializerFn = initializeTranslations(inject(TranslateService), inject(CookieService));
    return initializerFn();
});
